import Component from '@glimmer/component';

import { concat } from '@ember/helper';

import classMod from 'rise-ui/helpers/class-mod.js';
import trustedHtml from 'rise-ui/helpers/trusted-html.js';
import element_ from 'rise-ui/modifiers/element.js';
import { isFn } from 'rise-ui/utils/function.js';

export default class CColorComponent extends Component {
  get colorValue() {
    const { colors } = this.args;
    let { value } = this.args;
    if (isFn(colors)) {
      value = colors(value);
    }
    return value;
  }

  <template>
    <div
      class={{classMod "c-color"
        @disabled "--disabled"
        @show "--show"
        @hide "--hide"
        @hover "--hover"
      }}
      style={{trustedHtml (if this.colorValue (concat "background-color: " this.colorValue))}}
      ...attributes
    ><div {{element_ @canvas}} />{{yield}}</div>
  </template>
}
